import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets.v2/images/logo-sign-up.svg'


const _hoisted_1 = { class: "sign-up pop-up" }
const _hoisted_2 = { class: "sign-up__inner" }
const _hoisted_3 = { class: "sign-up__content" }
const _hoisted_4 = { class: "sign-up__logo-text-box" }
const _hoisted_5 = ["href"]
const _hoisted_6 = { class: "sign-up__form-box" }
const _hoisted_7 = {
  key: 0,
  class: "shortform-sign-up"
}
const _hoisted_8 = { class: "shortform-sign-up__group" }
const _hoisted_9 = { class: "shortform-sign-up__group" }
const _hoisted_10 = { class: "shortform-sign-up__submit button button--theme" }
const _hoisted_11 = {
  key: 1,
  class: "shortform-sign-up"
}

import { onMounted, ref } from 'vue'
import { useRoute } from 'vue-router'
import { useWait } from '../composables/useWait'

import { PasswordForgotView } from '@/models/auth/models'
import { authCssFix } from '@/helpers/html'
import { platform } from '@/services/platform'
import { waitTimer } from '@/helpers/timer'

import FormError from '@/components/ui/FormError.vue'
import InputWithContextMenu from '@/app/components/InputWithContextMenu.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'PasswordForgot',
  setup(__props) {

const wait = useWait()
const route = useRoute()

const view = ref(new PasswordForgotView())
const isNativeIOSApp = ref(false)

onMounted(async () => {
  // If user name was passed a prop (from the signup with email form)
  if (route.query.email) {
    view.value.model.email = route.query.email as string
  }

  isNativeIOSApp.value = await platform.isNativeIOSApp()
  authCssFix()
})

async function submitForm(): Promise<void> {
  wait.start('Submit')
  try {
    // Wait for submit to complete plus up to two seconds delay
    // to prevent fast clicking issues.
    await Promise.all([view.value.submitForm(), waitTimer(2000)])
  } finally {
    wait.end('Submit')
  }
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_button_spinner = _resolveComponent("button-spinner")!
  const _component_v_wait = _resolveComponent("v-wait")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("a", {
            class: "sign-up__logo",
            href: isNativeIOSApp.value ? '#' : '/'
          }, [...(_cache[1] || (_cache[1] = [
            _createElementVNode("img", {
              class: "sign-up__logo-img",
              src: _imports_0,
              alt: "Shortform"
            }, null, -1)
          ]))], 8, _hoisted_5)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        (view.value.state === 'form')
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _cache[6] || (_cache[6] = _createElementVNode("h2", { class: "shortform-sign-up__title" }, "Reset Password", -1)),
              _cache[7] || (_cache[7] = _createElementVNode("p", { class: "shortform-sign-up__p" }, " Enter your email below and we'll send you a link to reset your password. ", -1)),
              _createElementVNode("form", {
                role: "form",
                class: "shortform-sign-up__form",
                novalidate: "",
                onSubmit: _withModifiers(submitForm, ["prevent"])
              }, [
                _createElementVNode("div", _hoisted_8, [
                  _cache[3] || (_cache[3] = _createElementVNode("label", {
                    class: "shortform-sign-up__label",
                    for: "register_email"
                  }, "Email Address", -1)),
                  _createVNode(InputWithContextMenu, {
                    id: "email",
                    modelValue: view.value.model.email,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((view.value.model.email) = $event)),
                    class: _normalizeClass(["shortform-sign-up__input", view.value.validation.stateClass('email')]),
                    placeholder: "",
                    type: "email",
                    autocomplete: "username",
                    autofocus: ""
                  }, null, 8, ["modelValue", "class"]),
                  _createVNode(FormError, {
                    errors: view.value.validation.errors,
                    field: "email"
                  }, null, 8, ["errors"]),
                  _createVNode(_component_router_link, {
                    to: { name: 'login', query: _unref(route).query },
                    class: "shortform-sign-up__forgot-password"
                  }, {
                    default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                      _createElementVNode("strong", null, "Back to Login", -1)
                    ]))]),
                    _: 1
                  }, 8, ["to"])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_v_wait, { for: "Submit" }, {
                    waiting: _withCtx(() => [
                      _createElementVNode("span", _hoisted_10, [
                        _cache[4] || (_cache[4] = _createTextVNode(" Processing... ", -1)),
                        _createVNode(_component_button_spinner)
                      ])
                    ]),
                    default: _withCtx(() => [
                      _cache[5] || (_cache[5] = _createElementVNode("button", {
                        type: "submit",
                        class: "shortform-sign-up__submit button button--theme"
                      }, " Send reset link ", -1))
                    ]),
                    _: 1
                  })
                ])
              ], 32)
            ]))
          : _createCommentVNode("", true),
        (view.value.state === 'success')
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [...(_cache[8] || (_cache[8] = [
              _createElementVNode("p", null, " We've sent you an email, follow the instructions to reset your password. ", -1)
            ]))]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})